// ContextSourceChip — small provenance chip: which source a piece of
// intelligence came from (Gmail, Calendar, Drive, Outlook), plus an
// optional label and age. Pure presentational; no data fetching.
import React from 'react';

const SOURCE_ICONS = {
  gmail: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 7L12 14L22 7" />
    </svg>
  ),
  calendar: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <line x1="3" y1="10" x2="21" y2="10" />
      <line x1="8" y1="3" x2="8" y2="7" />
      <line x1="16" y1="3" x2="16" y2="7" />
    </svg>
  ),
  drive: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <path d="M6 3h8l5 5v12a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z" />
      <path d="M14 3v5h5" />
    </svg>
  ),
  outlook: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
      <rect x="2" y="5" width="20" height="14" rx="2" />
      <path d="M2 7L12 14L22 7" />
    </svg>
  ),
};

export default function ContextSourceChip({ source, label, age }) {
  const key = (source || '').toLowerCase();
  return (
    <span className="hm-source-chip" data-source={key}>
      <span className="hm-source-chip-icon" aria-hidden="true">
        {SOURCE_ICONS[key] || SOURCE_ICONS.drive}
      </span>
      <span className="hm-source-chip-source">{source}</span>
      {label && <span className="hm-source-chip-label">{label}</span>}
      {age && <span className="hm-source-chip-age">{age}</span>}
    </span>
  );
}
